import { h } from "preact";

import style from './style';

const BookDetailHeader = ({author, title}) => [
  <div class={style["author-name"]}>{author}</div>,
  <h2 class={style["book-title"]}>{title}</h2>
];

export default BookDetailHeader;
